import {api as axios} from '../shared/axios';
import useSWR from "swr";
import { API_URL } from "../shared/config";

const fetcher = (url) => axios.get(`${API_URL}${url}`);



// export const exportWidgetData = async (url) => {
//   try {
//     const request = await axios.get(`${API_URL}${url}?export=true`);
//     return { data: request?.data, error: undefined };
//   } catch (error) {
//     return { data: undefined, error: error };
//   }
// };

export const exportWidgetData = async (url, queries) => {
  try {
    const queryParams = queries ? new URLSearchParams(queries)?.toString() : "";
    const request = await axios.get(`${API_URL}${url}?${queryParams}`);
    
    
    return { data: request?.data, error: undefined };
  } catch (error) {
    return { data: undefined, error: error };
  }
};

// WIll be used on all widgets eventually
export const useWidgetDataRefreshInterval = ({url, refreshRate=0, useTimeRange=true,query={},queryFilter={},revalidateOnFocus=true}) => {
  let timeRange = localStorage.getItem("timeRange");
  const queryParams = new URLSearchParams(query)?.toString();
  const queryParamsFilter = new URLSearchParams(queryFilter)?.toString();
  let timeRangeUrl = timeRange && useTimeRange ? `${url}${timeRange}`: `${url}`; 


  if (query) {
    timeRangeUrl = `${url}${timeRange}&${queryParams}`;
  }
  if (queryParamsFilter) {
    timeRangeUrl = `${url}?${queryParamsFilter}`;
  }
  if (!query && !queryParamsFilter) {
    timeRangeUrl = timeRange && useTimeRange ? `${url}${timeRange}`: `${url}`;
  }

  if(url.includes("device_type")){
     const trimmedTimeRange = timeRange.startsWith('?') ? timeRange.slice(1) : timeRange;
     timeRangeUrl = `${url}&${trimmedTimeRange}`;
  }


  const { data, error, isLoading } = useSWR(timeRangeUrl, fetcher, { 
    refreshInterval: refreshRate*1000,
    revalidateOnFocus: revalidateOnFocus,
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
      if (error.status === 404) return // No need to retry 404 errors
      if (error.status === 429) return // No need to retry 429 errors (Too Many Requests error)
      if (retryCount >= 2) return // Only retry up to 2 times.
      // Retry after 20 seconds.
      setTimeout(() => revalidate({ retryCount }), 20000)
    }
  });
  return {
    data: data?.data,
    isLoadingWidget: isLoading,
    isErrorWidget: error,
  };
};





//TODO: the function to fetch widget data can be refactored (only one is needed), instead of multiple
export const useWidgetData = (url,hasTimeRange=false, extraRange=null) => {
  let timeRange = localStorage.getItem("timeRange"); //get the timeRange from the local storage
  if(timeRange=="all" && extraRange){
    timeRange = "";
  }else if(timeRange=="all" && !extraRange){
    timeRange = "?start=-12mo&stop=";
  }

  let timeRangeUrl = (timeRange && hasTimeRange)?`${url}${timeRange}`: `${url}`;  //if hasTimeRange is true, then add the timeRange query to the url

  const { data, error, isLoading } = useSWR(timeRangeUrl, fetcher);
  return {
    data: data?.data,
    isLoadingWidget: isLoading,
    isErrorWidget: error,
  };
};


export const useGetWidgetTemplates = (isCompany) => {
  const url = isCompany? `/widget/template/company/` : `/widget/template/`;
  const { data, error } = useSWR(url, fetcher);
  return {
    templates: data?.data,
    isLoading: !error && !data?.data,
    isError: error,
  };
};

export const useDeviceStatusWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    deviceStatus: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};
export const useRadarChartEnergyWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    radarChart: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};
export const useOverviewWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    overview: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};
export const useWeatherWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    weather: data?.data?.data,
    isSetup: data?.data?.is_setup,
    isLoadingWidget: !error && !data?.data?.data,
    isErrorWidget: error,
  };
};
export const useTimeCircleWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    TimeCircle: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};
export const useRealTimeEnergyWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    RealTimeEnergy: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};
export const useTotalValueWidget = (url) => {
  //TODO: refactor this function (use the function above useWigdetData)
  let timeRange = localStorage.getItem("timeRange");

  if(timeRange=="all"){
    timeRange = "?start=-12mo&stop=";
  }

  let _url = timeRange? `${url}${timeRange}`:url;



    const { data, error } = useSWR(_url, fetcher);
    return {
      TotalWidget: data?.data,
      isLoadingWidget: !error && !data?.data,
      isErrorWidget: error,
    };
  
  
};

export const useGraphOverViewWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    GraphOverView: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};


export const usePerformanceWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    PerformanceWidget: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};
export const useEfficiencyWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    EfficiencyWidget: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};
export const useCurrentStatusWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    currentStatus: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};
export const useNetZeroWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    netZero: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};
export const usePerformanceDeviceListWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    deviceList: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};

export const usePlantDetailsWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    plantDetails: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};

export const useWeatherAQIWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    weather: data?.data?.data,
    isSetup: data?.data?.is_setup,
    isLoadingWidget: !error && !data?.data?.data,
    isErrorWidget: error,
  };
};

export const usePlantLocationWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    plantLocation: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};

export const useStaticMapWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    staticMap: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};
//TODO: refactor all the battery( they can use just one function, same thing applies to the other widgets)
export const useBatteryWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    battery: data?.data?.data,
    isLoadingWidget: !error && !data?.data?.data,
    isErrorWidget: error,
  };
};

export const useBatteryAlarmWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    battery: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};

export const useBatteryPerformanceWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    batteryPerformance: data?.data?.data,
    isLoadingWidget: !error && !data?.data?.data,
    isErrorWidget: error,
  };
};


export const useIslandingWidget =(url) =>{
  const { data, error } = useSWR(url, fetcher)

  return {
    islanding: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};

export const useDeviceListControlWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    devices: data?.data?.data,
    isLoadingWidget: !error && !data?.data?.data,
    isErrorWidget: error,
  };
};

export const useRoomStateWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    roomStates: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};

export const useGasWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    gas: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};

export const useImageMockupWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    imageMockup: data?.data?.data?.url,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};

//TODO: might remove this later
export const useChillWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    imageMockup: data?.data?.data?.url,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};

export const useAirWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    airWidget: data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};

export const useChillerWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    chiller: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};

export const useRectifierWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    rectifier: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};

export const useEventLogWidget = (url) => {
  const { data, error } = useSWR(url, fetcher);
  return {
    eventLog: data?.data,
    isLoadingWidget: !error && !data?.data,
    isErrorWidget: error,
  };
};

export const useTrashUsageWidget = (url, year) => {
  // const { data, error } = useSWR(url, fetcher);
  const { data, error } = useSWR(`${url}?year_trash=${year}`, fetcher);
  return {
    allWaste: data?.data?.data,
    isLoadingWidget: !error && !data?.data?.data,
    isErrorWidget: error,
  };
};

export const updateTrash = async (widgetId,data, year) => {
    // const requestData = {
    //   setup:JSON.stringify({
    //     measurement: data
    //   })
    // }

    const requestData = { 
      fucsion: "waste",
      year: year,
      measurement: data
    }


    try {
        const request = await axios.patch(`${API_URL}/widget/${widgetId}/?fucsion=waste&year=${year}`,requestData);
        return { data: request.data, error: undefined };
    } catch (error) {
        return { data: undefined, error: error };
    }
}

// /api/device/{id ของ device}/info/?device_type=daikin_air
export const useGetDeviceKitchen = (id) => {
  const { data, error } = useSWR(`/device/${id}/info/?device_type=daikin_air`, fetcher)
  return {
    deviceKitchenList: data,
    isLoadingDeviceList: !error && !data,
    isErrorDeviceList: error
  }
}

export const controlKitchenDevice = async (deviceId,data) => {
  const requestData = {
    setup:JSON.stringify({
      measurement: data
    })
  }

  try {
      const request = await axios.post(`${API_URL}/device/${deviceId}/control/`,data);
      if(request.status === 200 && request?.data?.error){
        return { data: null, error: request?.data?.error };
      }
      return { data: request.data, error: undefined };
  } catch (error) {
      return { data: undefined, error: error };
  }
}


export const downloadCSVCompanyTHP = async (payload) => {
  try {
    const request = await axios.post(`${API_URL}/report/plant/dap_energy_report/`, payload);
    return { data: request.data, error: undefined };
  } catch (error) {
    return { data: undefined, error: error };
  }
};